<template>
  <main class="pdfLandscapeContainer padding">
    <div v-bind:class="config && config.type === 'document' ? 'a4' : ''">
      <!-- <div v-if="showWatermark && watermark" v-bind:class="isMobile ? 'marca-agua-mobile' : 'marca-agua'" > -->
      <div v-if="showWatermark && watermark" class="marca-agua" >
        <img :src="watermark" width="100%">
      </div>
      <div class="header">
        <label v-if="config && config.showTitleHead" class="title">{{ profileUserConfig.enterprise || title }}</label>
        <img v-if="logo && showLogo"
          :src="logo" alt="" class="modal-logo" height="95px"
        />
      </div>
      <div v-if="config && config.type === 'document'" class="infoHeader">
        <b-row class="mt-0 pt-0 mb-0 pb-0">
          <b-col cols="8" class="mt-0 pt-0 mb-0 pb-0">
            <span v-if="!logo" style="font-size: 36px;">{{ profileUserConfig.enterprise || title }}</span>
            <div v-else style="height: 60px"></div>
          </b-col>
        </b-row>
        <b-row class="mb-0 pb-0 mt-0 mt-0">
          <b-col cols="8">
            <span>{{ profileUserConfig.addressEnterprise }}</span>
          </b-col>
          <b-col cols="2">
          </b-col>
          <b-col cols="2">
            <section style="text-align: left;">
              Data: {{ headerData?.data?.dateFormated || headerData?.date || ""}}
            </section>
          </b-col>
        </b-row>
        <b-row class="mb-0 pb-0 mt-0 mt-0">
          <b-col cols="8">
            <span>{{ profileUserConfig.identityEnterprise }} - {{ profileUserConfig.telephoneEnterprise }} - {{ profileUserConfig.email }}</span>
          </b-col>
          <b-col cols="2">
          </b-col>
          <b-col cols="2">
            <section style="text-align: left;">
              {{ config.titleDocument }}: {{ headerData?.data?.numDoc || ""}}
            </section>
          </b-col>
        </b-row>
        <b-row class="mb-4 mt-0">
          <b-col cols="8">
            <span></span>
          </b-col>
          <b-col cols="1">
          </b-col>
          <b-col cols="3">
          </b-col>
        </b-row>
        <b-row class="mb-0">
          <b-col cols="8">
            <span>Cliente: {{ headerData?.data?.nameCustomer || "-" }}</span>
          </b-col>
          <b-col cols="1">
          </b-col>
          <b-col cols="3">
          </b-col>
        </b-row>
        <b-row class="mb-0">
          <b-col cols="8">
            <span>Telefone: {{ headerData?.data?.customer.cellPhone || "-" }}</span>
          </b-col>
          <b-col cols="1">
          </b-col>
          <b-col cols="3">
          </b-col>
        </b-row>
        <b-row class="mb-0">
          <b-col cols="8">
            <span>CPF/CNPJ: {{ headerData?.data?.customer.identityDocument || "-" }}</span>
          </b-col>
          <b-col cols="1">
          </b-col>
          <b-col cols="3">
          </b-col>
        </b-row>
        <b-row class="mb-0">
          <b-col cols="8">
            <span>Endereço: {{ headerData?.data?.customer.address || "-" }}, {{ headerData?.data?.customer.city || "-" }} - {{ headerData?.data?.customer.state || "-" }}</span>
          </b-col>
          <b-col cols="1">
          </b-col>
          <b-col cols="3">
          </b-col>
        </b-row>
        <b-row class="mb-0">
          <b-col cols="8">
            <span>CEP: {{ headerData?.data?.customer.zipCode || "-" }}</span>
          </b-col>
          <b-col cols="1">
          </b-col>
          <b-col cols="3">
          </b-col>
        </b-row>
      </div>
      <div v-else class="infoHeader">
        <label>{{ title }} </label>
        <b-row>
          <br />
          <b-col cols="2">
            <label>Data de emissão</label>
            <br />
            <div class="info">
              {{ headerData.date || '-' }}
            </div>
            <br />
          </b-col>
          <b-col cols="2">
            <label>Hora</label>
            <br />
            <div class="info">
              {{ headerData.hour || '-' }}
            </div>
            <br />
          </b-col>
          <b-col cols="8">
            <label>Usuário</label>
            <br />
            <div class="info">
              {{ headerData.user ||'-' }}
            </div>
            <br />
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col>
            <div v-for="key in filtersKeys" v-bind:key="key">
              <label>{{`${key}: ${filterData[key]}`}}</label>
              <br/>
            </div>
          </b-col>
          <b-col v-if="filterData && (filterData.initDate || filterData.endDate)">
            <label>Periodo: De {{ filterData.initDate }} até {{ filterData.endDate }}</label>
            <br />
            <label>Total de registros: {{ headerData ? headerData.qtdRows : '-' }}</label>
          </b-col>
        </b-row>
      </div>

      <div>
        <b-table
          striped
          :items="rows"
          :fields="fields"
          :class="fontSize"
        >
          <template #cell(balance)="row">
            <div class="text-right">{{ row.amount }}</div>
          </template>
          <template #cell(renda)="row">
            <div class="text-right">{{ row.incomme }}</div>
          </template>
          <template #cell(despesa)="row">
            <div class="text-right">{{ row.expense }}</div>
          </template>

        </b-table>
      </div>
      <div v-if="config && config.type === 'document'" class="infoHeader">
        <div v-if=" config && !config.hideTotals">
          <b-row class="mb-4">
              <div class="pl-3 pr-3 w-100"><div class="border-top"></div></div>
              <b-col cols="8" >
              </b-col>
              <b-col cols="2" >
                <section class="total-style">
                  Total:
                </section>
              </b-col>
              <b-col cols="2">
                <section class="pr-3 total-style">
                  {{ numberFormatted(headerData?.data?.grandTotal || "0") }}
                </section>
              </b-col>
          </b-row>
        </div>
        <div>
          <div v-if="headerData.data?.saleTaxes && Object.keys(headerData.data.saleTaxes).length > 0" class="text-parcela number-class">
            <span>Tributos: |</span>
            <span v-for="(value, key) in headerData.data.saleTaxes" :key="key">
              {{ key }}: {{ numberFormatted(value) }} |
            </span>
          </div>
          <div
              v-if="(headerData.data?.toReceiveDocument
                && headerData.data.toReceiveDocument.toReceive
                && headerData.data.toReceiveDocument.toReceive.length > 1)
                || (headerData.data?.toReceiveDocument
                && headerData.data.toReceiveDocument.toReceive
                && headerData.data.toReceiveDocument.toReceive[0].status === 'ACTIVE')"
          >
            <div class="mt-3" style="width: 100%; text-align: center; border: 1px solid #383838">
              <span><b>Convênio de pagamento</b></span>
            </div>
            <table class="installment-table">
              <thead>
                <tr>
                  <th>Parcela</th>
                  <th>Vencimento</th>
                  <th>Valor</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(inst, index) in headerData.data.toReceiveDocument.toReceive" :key="inst.idToReceive"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ formatterSimple(inst.toReceiveDate) }}</td>
                  <td class="pr-1" style="text-align: right;">{{ inst.amount }}</td>
                  <td>{{ STATUS_RECEIVE[inst.status] }}</td>

                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div v-if="config && config.type === 'document'" class="pt-2 pb-2 border-top border-bottom">
      <span style="font-weight: bold;">Observações: </span><span>{{ headerData?.data?.comments || "" }}</span>
    </div>
    <div v-if="footer && footer.lines" v-bind:class="footer && footer.textAlign ? footer.textAlign : 'left'">
      <span v-for="line in footer.lines" :key="line" style="font-weight: bold; font-size: 18px;">
        {{ line }}<br>
      </span>
    </div>
    <div class="footer">
        <span>Sistema desenvolvido por Samir Gannem - Informática SG - https://informaticasg.com.br</span>
    </div>
  </main>
</template>

<script>

	import { numberFormatted, formatterSimple } from "@/helpers/common";
	import { STATUS_RECEIVE } from "@/helpers/enums";

	export default {
		components: {},

		computed: {
			headers () {
				return this.rows.length && Object.keys(this.rows[0]);
			},
			filtersKeys () {
				return Object.keys(this.filterData).filter((key) => key !== "initDate" && key !== "endDate");
			},
			fontSize () {
				if (!this.headers || !this.headers.length) return "fs-16";
				const cols = this.headers.length;
				if (cols <= 6) return "fs-16";
				if (cols <= 8) return "fs-14";
				if (cols <= 10) return "fs-12";
				if (cols <= 12) return "fs-10";
				return "fs-9";
			}
		},

		props: {
			headerData: {
				type: Object,
				default () {
					return {};
				}
			},
			filterData: {
				type: Object,
				default () {
					return {};
				}
			},
			rows: {
				type: Array
			},
			title: {
				type: String,
				default: ""
			},
			fields: {
				type: Array
			},
			config: {
				type: Object,
				require: false
			},
			showLogo: {
				type: Boolean,
				require: false,
				default: false
			},
			showWatermark: {
				type: Boolean,
				require: false,
				default: false
			},
			isMobile: {
				type: Boolean,
				require: false,
				default: false
			},
			installments: {
				type: Array,
				require: false,
				default: null
			},
			footer: {
				type: Object,
				required: false,
				default: null
			}
		},

		data () {
			return {
				profileUserConfig: {},
				logo: null,
				numberFormatted,
				watermark: null,
				STATUS_RECEIVE,
				formatterSimple,
				rowsOnReport: 6,
				totalsRows: 34
			};
		},

		watch: {
			showLogo: "getLogo",
			showWatermark: "getWatermark"
		},

		mounted () {
			this.profileUserConfig = localStorage.params ? JSON.parse(localStorage.params) : {};
			this.getLogo();
			this.getWatermark();
		},

		methods: {
			getLogo () {
				if (this.showLogo) {
					this.logo = this.profileUserConfig.logo;
				}
			},

			getWatermark () {
				if (this.showWatermark) {
					this.watermark = this.profileUserConfig.watermark || this.logo;
				}
			}
		}
	};
</script>

<style scoped>
.center {
  text-align: center;
}

.right {
  text-align: right;
}

.left {
  text-align: left;
}

.a4 {
  width: 28cm;
  height: 35cm;
  overflow: hidden !important;
}

.border-top {
  border-top: 1px solid #9c9b9b !important;
}

.border-bottom {
  border-bottom: 1px solid #9c9b9b !important;
  padding-bottom: 3px;
}

.footer {
  width: 28cm;
  margin-top: 48px;
  text-align: left;
  border-top: 1px solid #9c9b9b;
  font-style: italic;
  font-size: 14px;
  overflow: hidden !important;
}

.marca-agua {
  position: fixed;
  text-align: center;
  top: calc(100vh / 2);
  opacity: 0.1;
  z-index: 0;
  width: 1050px;
}

/* .marca-agua {
  position: fixed;
  top: 53%;
  left: 24%;
  opacity: 0.1;
  z-index: 0;
  width: 1050px;
} */

.marca-agua-mobile {
  position: fixed;
  top: 40%;
  left: 9%;
  opacity: 0.1;
  z-index: 0;
  width: 1050px;
}

.contenido {
  position: relative;
  z-index: 1;
}

.total-style {
  text-align: right;
  font-size: 20px;
  font-weight: bold;
}

.column-width {
  /* max-width: 100px; */
  overflow: hidden;
}

* {
  font-weight: 400;
  font-size: 16px;
}

.fs-9 {
  font-size: 9px;
}
.fs-10 {
  font-size: 10px;
}
.fs-12 {
  font-size: 12px;
}
.fs-14 {
  font-size: 14px;
}
.fs-16 {
  font-size: 16px;
}

.subTitle {
  font-weight: 600;
}

.pdfLandscapeContainer {
  width: 30cm;
  height: 37cm;
  /* width: 842pt;
  height: 950pt; */
}

.padding {
  padding: 36px;
  font-weight: 400;
}

label {
  margin-bottom: 3px;
}

.info {
  margin-bottom: 12px;
}

.underline {
  flex-grow: 1;
  /* width: 100%; */
  border-bottom: 1px solid black;
  margin-left: 5px;
  margin: 0 10px 4px 5px;
}

.div-assinaturas {
  display: flex;
  margin-bottom: 10px;
}

.infoHeader {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.infoHeader h2 {
  font-size: 16px;
  font-weight: 600;
}

.modal-header {
  border-bottom: 0;
}

.header .modal-logo {
  position: absolute;
  left: 38px;
  top: 0px;
  margin-top: 0px;
}

.header .title {
  font-weight: 500;
  font-size: 18px;
  margin-top: -30px;
  margin-bottom: 40px;
  margin-left: -10px;
}

	.installment-table tbody td {
		border: 1px solid #383838;
    padding-left: 6px
	}

	.installment-table {
    width: 100%;
		border: 1px solid #383838;
		text-align: left;
    border-collapse: collapse;
    table-layout: fixed;
	}

	.installment-table th {
		border: 1px solid #383838;
    padding-left: 6px
	}

</style>